export default __webpack_public_path__ + "ebcecff23ad383299e0badca82a4ba10.svg";